import { createFileRoute } from "@tanstack/react-router"

import Markdown from "@/components/markdown"
import content from "@/terms/content.md?raw"

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [{ title: "Terms of Service | WattBot" }],
  }),
})

function TermsPage() {
  return (
    <div className="mx-auto max-w-(--breakpoint-sm)">
      <Markdown>{content}</Markdown>
    </div>
  )
}
